export function getNoticeEventRequestErrorMessage(error, fallbackMessage) {
    const responseMessage = error?.response?.data?.message;
    if (typeof responseMessage === 'string' && responseMessage.trim()) {
        return responseMessage;
    }
    return fallbackMessage;
}
